var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h5',[_vm._v("Your Company ")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.company.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }